import React from 'react';
import StyledTable from '@shared/components/StyledTable';
import SurveyLabelColumn from './SurveyLabelColumn';
import SurveyYearlyValue from './SurveyYearlyValue';
import SurveyChartUtils from '../shared/SurveyChartUtils';

/**
 * @typedef {object} SurveyTableProps
 * @property {Array<*>} [surveyResults]
 * @property {boolean} [isEditMode]
 * @property {boolean} [loading]
 * @property {number} [questionIndex]
 */

/**
 * @param {SurveyTableProps} props
 */
const SurveyTable = props => {
  const { isEditMode, loading, surveyResults, questionIndex } = props;
  const years = SurveyChartUtils.getSurveyYears(surveyResults);

  const maxYear = Math.max(...years);
  const columns = [
    {
      title: '',
      dataIndex: 'Label',
      render: (_, record) => <SurveyLabelColumn record={record} />
    },
    ...years.map(year => ({
      title: year === maxYear ? `${year}-YTD` : `${year}`,
      render: record => (
        <SurveyYearlyValue
          year={year}
          record={record}
          isEditMode={isEditMode}
          allResults={surveyResults}
          questionIndex={questionIndex}
        />
      )
    }))
  ];

  return (
    <StyledTable
      className='survey-results__table'
      data-testid={`result-survey-table-${questionIndex}`}
      rowKey='Label'
      dataSource={surveyResults}
      columns={columns}
      pagination={false}
      overflowX='auto'
      loading={loading}
    />
  );
};

export default SurveyTable;
